import { useMemo } from 'react';
import ReactModal from 'react-modal';
import { Title } from '../text';
import { Button } from '../buttons/Button';
import { useTranslation } from 'react-i18next';
import { Block } from '../blocks/Block';
import { BLOCK } from '../../../constants/common';
import { useDeviceSizeListener } from '../../../hooks/common/mobile/useDeviceSizeListener';
import { useModalBackButton } from '../../../hooks/common/useModalBackButton';

ReactModal.setAppElement('#root');

const useModalStyles = () => {
    const { isMobile } = useDeviceSizeListener({ breakpoint: 1024 });

    return useMemo(() => ({
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            opacity: 1,
            width: isMobile ? '90%' : '35%',
            boxSizing: isMobile ? 'border-box' : 'content-box',
            maxWidth: '100%',
            maxHeight: '80vh',
            overflowY: 'auto',
            zIndex: '100',
        },
        overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
        },
    }), [isMobile]);
};

const stopReactBubble = (e) => e.stopPropagation();

export const Modal = ({
    children,
    contentLabel,
    isOpen,
    onRequestClose,
    text = 'continue',
    withContinue = false,
    className = 'btn btn-continue',
    closeOnBack = true,
}) => {
    const { t } = useTranslation();
    const modalStyles = useModalStyles();

    useModalBackButton(closeOnBack && isOpen, onRequestClose);

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={modalStyles}
            contentLabel={contentLabel || ''}
        >
            <div
                role="presentation"
                onClick={stopReactBubble}
                onMouseDown={stopReactBubble}
            >
                {contentLabel && (
                    <>
                        <Title>{contentLabel}</Title>
                        <br />
                    </>
                )}
                {children}
                <br />
                {withContinue && onRequestClose && (
                    <Block name={BLOCK.CENTER}>
                        <Button
                            text={t(`${text}`)}
                            onClick={onRequestClose}
                            className={className}
                        />
                    </Block>
                )}
            </div>
        </ReactModal>
    );
};
